// specs/018-ai-deal-form-assistant — mounts the AI intake app (Screen 1, loading dialog, Screen 2).
import React from 'react';
import {createRoot} from 'react-dom/client';
import DealIntakeApp from '../../components/deal_intake/DealIntakeApp';

window.DealIntake = {
    init() {
        const container = document.getElementById('deal-intake-root');
        const dataEl = document.getElementById('deal-intake-data');
        if (!container || !dataEl) {
            return;
        }

        let data;
        try {
            data = JSON.parse(dataEl.textContent);
        } catch (e) {
            window.sentry?.captureException(e);
            return;
        }

        createRoot(container).render(<DealIntakeApp {...data} />);
    },
};
